import type { NodeId, PointCloudOptions } from 'web';
import type { FlowGraph } from '../FlowGraph';
import type { PointCloudFromDepthData } from '@/types/node';

export class PointCloudView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  private getOptions(): PointCloudOptions | undefined {
    return this.graph.store.getNodeDataNullable<PointCloudFromDepthData>(this.nodeId)?.options;
  }

  setDepthScale(value: number, ongoing: boolean) {
    const options = this.getOptions();
    if (!options) return;
    this.graph.wasmEdit((wasm) => wasm.setPointCloudOptions(this.nodeId, { ...options, depthScale: value }), ongoing);
    this.graph.updateNodeOutputs(this.nodeId, ongoing);
  }

  setDepthLevels(minDepth: number, maxDepth: number, gammaDepth: number, ongoing: boolean) {
    const options = this.getOptions();
    if (!options) return;
    this.graph.wasmEdit(
      (wasm) => wasm.setPointCloudOptions(this.nodeId, { ...options, minDepth, maxDepth, gammaDepth }),
      ongoing,
    );
    this.graph.updateNodeOutputs(this.nodeId, ongoing);
  }
}
